import React, {useState} from "react";
import { FormGroup, InputGroup } from "components/common/Forms";
import { LocalForm, Control, actions } from "react-redux-form";
import { Trans } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Col, Row, Button } from "reactstrap";
import { colStyle } from "./CoreComponents";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import { isNumericString } from "services/util";
import { ApiClient } from "services";
import { ExSpan } from "pages/Xero/Settings/TaxReturnsDetail";

export const EditForm = ({
    t,
    match,
    item,
    options,
    category,
    type,
    pushURL,
  }) => {

  const [selectedOption, setSelectedOption] = useState('');
  const [isSending, setIsSending] = useState()

  const handleCodeChange = (selectedValue) => {
    setSelectedOption(selectedValue);
  };

  const history = useHistory();
  const client = ApiClient()

  const isEdit = isNumericString(match.params.id)? true : false
  const isModule = type === "Module"
  const isApplication = type === "Application"
  
  const monthlyList = item?.subscription_prices?.findIndex(item => item.plan_type === 'Monthly') || 0
  const yearlyList = item?.subscription_prices?.findIndex(item => item.plan_type === 'Yearly') || 1
  const lifetimeList = item?.subscription_prices?.findIndex(item => item.plan_type === 'Lifetime') || 2
  const nameLanguage = options?.find(option => option.value === selectedOption)?.label || item?.name
  
  const handlePost = async (values) => {

    setIsSending(true)
    
    const { 
      monthly_price, 
      yearly_price, 
      lifetime_price,
      code, 
      description, 
      name, 
      active, 
      subscription_prices, 
      vat_monthly , 
      vat_yearly,
      vat_lifetime, 
      category,
      model,
      store_icon,
      connect_url,
      disconnect_url,
      in_connect,
      converters_location,
      prefix
    } = values;

    let endpoint = isEdit ? `/${match.params.id}`:''
    let method = isEdit ? "put":"post"

    const postPriceMissing = !isEdit && (!monthly_price || !yearly_price);
    const putPriceMissing = isEdit && (!subscription_prices?.[yearlyList]?.price && !yearly_price || !subscription_prices?.[monthlyList]?.price && !monthly_price);

    if (postPriceMissing || putPriceMissing) {
      NotificationManager.error(t(`Please add the prices${" for the " + type || ""}`))
      setIsSending(false)
      return
    }

    const createPlan = (plan_type, price, currency, is_vat_included) => ({
      currency,
      plan_type,
      price,
      is_vat_included,
    });
    
    const monthlyPlan = createPlan("Monthly", monthly_price, "SAR", vat_monthly);
    const yearlyPlan = createPlan("Yearly", yearly_price, "SAR", vat_yearly);
    const lifetimePlan = createPlan("Lifetime", lifetime_price, "SAR", vat_lifetime);

    const yearlyPlanUpdate = createPlan("Yearly", subscription_prices?.[yearlyList]?.price, "SAR", subscription_prices?.[yearlyList]?.is_vat_included);
    const monthlyPlanUpdate = createPlan("Monthly", subscription_prices?.[monthlyList]?.price, "SAR", subscription_prices?.[monthlyList]?.is_vat_included);
    const lifetimePlanUpdate = createPlan("Lifetime", subscription_prices?.[lifetimeList]?.price, "SAR", subscription_prices?.[lifetimeList]?.is_vat_included);

    const commonValues = {
      description: description,
      active: active,
      ...(isModule && { category: category }),
      ...(isApplication && {
        model,
        store_icon,
        connect_url,
        disconnect_url,
        in_connect,
        converters_location,
        prefix
      })
    };
    
    const postValues = {
      ...commonValues,
      name: nameLanguage,
      code: code,
      subscription_price_detail: [monthlyPlan, yearlyPlan, lifetimePlan],
    };
    
    const patchValues = {
      ...commonValues,
      ...(isModule && { name: name }),
      subscription_price_detail: item && !item.subscription_prices?.length ? [monthlyPlan, yearlyPlan, lifetimePlan] : [monthlyPlanUpdate, yearlyPlanUpdate, lifetimePlanUpdate],
    };
    
    const finalValues = isEdit ? patchValues : postValues

    client[method](`/core/hesaab_${type.toLowerCase()}${endpoint}`, finalValues)
      .then(response => {
        if (method === 'post') {
          console.log("Server response:", response.data);
          setTimeout(() => {
            NotificationManager.success(t(`${type} Added Successfully!`));
            setIsSending(false);
            setTimeout(() => {
              history.push(pushURL);
            }, 500);
          }, 1000);
        } else {
          console.log("Server response:", response.data);
          setTimeout(() => {
            NotificationManager.success(t(`${type} Updated Successfully!`));
            setIsSending(false);
            setTimeout(() => {
              history.push(pushURL);
            }, 500);
          }, 1000);
        }
        return true;
      })
      .catch(error => {
        console.error("Error:", error);
        if (error.response && error.response.data) {
          const errors = error.response.data;
          Object.entries(errors).forEach(([key, value]) => {
            const errorMessage = `${key.charAt(0).toUpperCase() + key.slice(1)} - ${value}`;
            NotificationManager.error(errorMessage);
          });
        } else {
          NotificationManager.error(t("An error occurred while saving"));
        }
        setIsSending(false);
      });
};

const select = item?.name ? "Selected" : "Select"

    return (
      <LocalForm
      initialState={item}
      onSubmit={values => handlePost(values)}
    >
      <Row>
      <Col {...colStyle}>
        <FormGroup label={`${type} ${select}`} model=".code" addControlClass={isEdit}>  
          {!isEdit ? 
            <Control.text
              style={{ backgroundColor: '#F4F7FE' }}
              model=".code"
              component={Select}
              options={options}
              simpleValue
              clearable={false}
              placeholder={t(`Select ${type}`)}
              onChange={(selectedValue) => handleCodeChange(selectedValue)}
            />
            :
            <Control.text disabled model=".placeholder" placeholder={item?.name}/>
          }
        </FormGroup>
      </Col>
      {isEdit && isModule &&
        <Col {...colStyle}>
          <FormGroup label="Change Display Name">
            <Control.text model=".name"/>
          </FormGroup>
        </Col>
      }
      {isModule && 
      <Col {...colStyle}>
        <FormGroup label="Category*" model=".category" addControlClass={false}>
          <Control.text
            style={{ backgroundColor: '#F4F7FE' }}
            model=".category"
            component={Select}
            options={category}
            simpleValue
            clearable={false}
            placeholder="Select Category"
          />
        </FormGroup>
      </Col>}
      <Col {...colStyle}>
        <FormGroup label="Description *" model=".description">
          <Control.textarea rows="4" model=".description" className="border"/>
          <p className="mb-0 form-text text-muted small"><Trans>A brief description for this {type}.</Trans></p>
        </FormGroup>
      </Col>

        {
          type === 'Application' && <>

            <Col {...colStyle}>
              <FormGroup label={t(`Prefix`)} model=".prefix">
                <Control.text
                  model='.prefix'
                  placeholder={t("Prefix")}
                />
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label={t(`Django model`)} model=".model">
                <Control.text
                  model='.model'
                  placeholder={t("Django model")}
                />
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label={t(`Store icon`)} model=".store_icon">
                <Control.text
                  model='.store_icon'
                  placeholder={t("Store icon")}
                />
              </FormGroup>
            </Col>

            <Col {...colStyle}>
              <div className="my-3">
                <span><Control.checkbox model=".is_connect" defaultValue={true} /> <Trans>Is In-connect</Trans></span>
              </div>
            </Col>

            <Col {...colStyle}>
              <FormGroup label={t(`Connect URL`)} model=".connect_url">
                <Control.text
                  model='.connect_url'
                  placeholder={t("Connect URL")}
                />
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label={t(`Disconnect URL`)} model=".disconnect_url">
                <Control.text
                  model='.disconnect_url'
                  placeholder={t("Disconnect URL")}
                />
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label={t(`Converter location`)} model=".converters_location">
                <Control.text
                  model='.converters_location'
                  placeholder={t("Converter location")}
                />
              </FormGroup>
            </Col>

          </>
        }

        <Col {...colStyle}>
          <div className="my-3">
            <span><Control.checkbox model=".active" defaultValue={true} /> <Trans>Activate</Trans></span>
          </div>
        </Col>
      </Row>
      
      {!isEdit || (item && !item.subscription_prices.length ) ? <>
      <Row>
      <Col md="4" xs={false}>
        <FormGroup label="Monthly Price*">
        <InputGroup suffixText="SAR">
          <Control.text
            maxLength="10"
            model='.monthly_price'
            placeholder={t("Price")}
          />
        </InputGroup>
        </FormGroup>
      </Col>
      <Col md="4" xs={false}>
        <FormGroup label="Yearly Price*">
        <InputGroup suffixText="SAR">
          <Control.text
            maxLength="10"
            model='.yearly_price'
            placeholder={t("Price")}
          />
        </InputGroup>
        </FormGroup>
      </Col>
      <Col md="4" xs={false}>
        <FormGroup label="Lifetime Price*">
          <InputGroup suffixText="SAR">
            <Control.text
              maxLength="10"
              model='.lifetime_price'
              placeholder={t("Price")}
            />
          </InputGroup>
        </FormGroup>
      </Col>
      </Row>
      <Row>
        <Col md="4" xs={false}>
          <div className="my-3">
            <Control.checkbox model=".vat_monthly" defaultValue={true} /> <Trans>Is Vat included</Trans>
          </div>
        </Col>
        <Col md="4" xs={false}>
          <div className="my-3">
            <span><Control.checkbox model=".vat_yearly" defaultValue={true} /> <Trans>Is Vat included</Trans></span>
          </div>
        </Col>
        <Col md="4" xs={false}>
          <div className="my-3">
            <Control.checkbox model=".vat_lifetime" defaultValue={true} /> <Trans>Is Vat included</Trans>
          </div>
        </Col>
      </Row>
      </>
      :
      <>
      <Row>
        <Col md="4" xs={false}>
        <FormGroup label="Monthly Price">
          <InputGroup suffixText="SAR">
            <Control.text
            maxLength="10"
            model={`.subscription_prices[${monthlyList}].price`}
            placeholder={t("Price")}
          />
          </InputGroup>
        </FormGroup>
        </Col>
        <Col md="4" xs={false}>
        <FormGroup label="Yearly Price">
        <InputGroup suffixText="SAR">
          <Control.text
            maxLength="10"
            model={`.subscription_prices[${yearlyList}].price`}
            placeholder={t("Price")}
          />
        </InputGroup>
        </FormGroup>
        </Col>
        <Col md="4" xs={false}>
          <FormGroup label="Lifetime Price">
            <InputGroup suffixText="SAR">
              <Control.text
                maxLength="10"
                model={`.subscription_prices[${lifetimeList}].price`}
                placeholder={t("Price")}
              />
            </InputGroup>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md="4" xs={false}>
          <div className="my-3">
            <Control.checkbox model={`.subscription_prices[${monthlyList}].is_vat_included`}/> <Trans>Is Vat included</Trans>
          </div>
        </Col>
        <Col md="4" xs={false}>
          <div className="my-3">
            <span><Control.checkbox model={`.subscription_prices[${yearlyList}].is_vat_included`}/> <Trans>Is Vat included</Trans></span>
          </div>
          </Col>
          <Col md="4" xs={false}>
            <div className="my-3">
              <Control.checkbox model={`.subscription_prices[${lifetimeList}].is_vat_included`} /> <Trans>Is Vat included</Trans>
            </div>
          </Col>
        </Row>
      </>}
            
      <FormGroup className="my-3 d-flex justify-content-end">
        {!isSending? <Button className="px-3 m-0">Save</Button> : <Button className="px-3 m-0" disabled><span className="fa fa-spinner fa-spin" /> Saving</Button> }
      </FormGroup>

    </LocalForm>
  )};
  